import jwt from "jsonwebtoken";

import UsersService from "@/services/UsersService";

function checkTokenValid (token) {
  if (token) {
    const decodedToken = jwt.decode(token);
    return decodedToken && decodedToken.exp * 1000 > new Date().getTime();
  }
}

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("usertoken") || "",
    username: localStorage.getItem("username") || "",
    entityTag: localStorage.getItem("entityTag") || "",
    profile: null
  },
  mutations: {
    authSuccess (state, { token, username, entityTag }) {
      state.status = "success";
      state.token = token;
      state.username = username;
      state.entityTag = entityTag;
    },
    authError (state) {
      state.status = "error";
    },
    logOut (state) {
      state.token = "";
      state.username = "";
    },
    setProfile (state, profile) {
      state.profile = { ...profile };
    }
  },
  actions: {
    logIn ({ commit }, user) {
      return UsersService.logIn(user)
        .then(res => {
          const status = res.data.status || false;
          if (status) {
            const token = res.data.token || "";
            const decode = jwt.decode(token);
            localStorage.setItem("usertoken", token);
            localStorage.setItem("username", decode.username);
            localStorage.setItem("entityTag", decode.entityTag);
            commit("authSuccess", {
              token,
              username: decode.username,
              entityTag: decode.entityTag
            });
          }
          return res;
        })
        .catch(() => {
          commit("authError");
          localStorage.removeItem("usertoken");
        });
    },
    logOut ({ commit }) {
      return new Promise(resolve => {
        commit("logOut");
        localStorage.clear();
        resolve();
      });
    },
    async getProfile ({ state, commit }) {
      const { username, token } = state || {};
      if (username) {
        try {
          const res = await UsersService.fetchProfile({ username }, token);
          if (res.data.status) {
            commit("setProfile", res.data.user);
          }
          return res;
        } catch (err) {
          throw new Error(err);
        }
      }
    },
    async changePasswordUserDMA ({ state }, userData) {
      const { entityTag, token } = state;
      const newUserData = { ...userData };
      newUserData.user.entityTag = entityTag;
      if (entityTag) {
        try {
          const res = await UsersService.updateUserDMAPassword(
            newUserData,
            token
          );
          return res;
        } catch (err) {
          throw new Error(err);
        }
      }
    },
    resendEmail (undefined, email) {
      UsersService.resendEmail(email).then(res => {
        return res;
      });
    }
  },
  getters: {
    isLoggedIn: state => checkTokenValid(state.token),
    getUserType: state => {
      const decodedToken = jwt.decode(state.token);
      return decodedToken && decodedToken.type||0
    }
    // isLoggedIn: state => !!state.token && checkTokenValid(state.token),
  }
};
